"use client";

import { EntityFeed } from "@model/entity/shape";
import { createContext, useContext, useState, ReactNode } from "react";

interface EntityContext {
    entityFeed: EntityFeed | null;
    setEntityFeed: (feed: EntityFeed | null) => void;
}

const EntityContext = createContext<EntityContext | undefined>(undefined);

export const EntityProvider = ({ children }: { children: ReactNode }) => {
    const [entityFeed, setEntityFeed] = useState<EntityFeed | null>(null);

    return (
        <EntityContext.Provider value={{ entityFeed, setEntityFeed }}>
            {children}
        </EntityContext.Provider>
    );
};

// Custom hook to access user context
export const useEntityContext = () => {
    const context = useContext(EntityContext);
    if (!context) {
        throw new Error(
            "useEntityContext must be used within a EntityContextProvider",
        );
    }
    return context;
};
